<div class="container">
    <div class="row">
        <div class="col">
            <div class="text-center my-5">
                <h1 class="display-4 fw-bold text-primary">Unsere Preismodelle</h1>
                <div class="border-bottom border-primary mx-auto" style="width: 100px; margin-top: 15px;"></div>
                <p class="lead mt-3">Transparente Preise für jede Unternehmensgröße - wählen Sie das passende Paket für Ihre Bedürfnisse</p>
            </div>

            <div class="row mb-5">
                <div class="col-lg-6 mb-4 mb-lg-0">
                    <div class="card card-lg h-100 pricing-card">
                        <div class="card-header bg-primary text-white text-center py-4">
                            <h3 class="mb-0">Kleinunternehmen</h3>
                            <p class="mb-0 mt-2">Ideal für Unternehmen mit weniger als 20 Standorten</p>
                        </div>
                        <div class="card-body">
                            <div class="text-center mb-4">
                                <span class="display-4 lh-1 text-dark">€30<span class="fs-4">.00</span></span>
                                <span class="d-block text-muted">EUR / Monat pro Betriebsstätte</span>
                            </div>

                            <div class="pricing-features mb-4">
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Unlimitierte Benutzer</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Unbegrenzte Dokumente (1 GB pro Betriebsstätte)</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Grundlegende Dokumentenverwaltung</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Erinnerungsfunktion</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3 text-muted">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Automatische Digitalisierung</span>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="button" class="btn btn-primary btn-lg w-100" [routerLink]="['/offer']">
                                    <i class="fas fa-paper-plane mr-2"></i>Angebot anfordern
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card card-lg h-100 pricing-card border-primary">
                        <div class="card-header bg-primary text-white text-center py-4">
                            <h3 class="mb-0">Mittelgroße Unternehmen</h3>
                            <p class="mb-0 mt-2">Optimal für Unternehmen ab 20 Standorten</p>
                        </div>
                        <div class="card-body">
                            <div class="text-center mb-4">
                                <span class="display-4 lh-1 text-dark">€24<span class="fs-4">.00</span></span>
                                <span class="d-block text-muted">EUR / Monat pro Betriebsstätte</span>
                            </div>

                            <div class="pricing-features mb-4">
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Unlimitierte Benutzer</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Unbegrenzte Dokumente (1 GB pro Betriebsstätte)</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Erweiterte Dokumentenverwaltung</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Erinnerungsfunktion</span>
                                </div>
                                <div class="feature-item d-flex align-items-center mb-3 text-muted">
                                    <i class="fas fa-check-circle text-success mr-2"></i>
                                    <span>Automatische Digitalisierung</span>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="button" class="btn btn-primary btn-lg w-100" [routerLink]="['/offer']">
                                    <i class="fas fa-paper-plane mr-2"></i>Angebot anfordern
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="custom-offer-section text-center p-4 bg-light rounded mb-5">
                <h3 class="mb-3">Testen Sie NoteRadar kostenlos oder fordern Sie ein individuelles Angebot an</h3>
                <p class="mb-4">Erstellen Sie einen kostenlosen Demozugang mit vollem Funktionsumfang für 3 Tage oder lassen Sie sich ein maßgeschneidertes Angebot erstellen, das perfekt auf die Anforderungen Ihres Unternehmens zugeschnitten ist.</p>
                <div class="d-flex justify-content-center flex-wrap">
                    <button type="button" class="btn btn-success btn-lg mr-3 mb-2" [routerLink]="['/demo']">
                        <i class="fas fa-play-circle mr-2"></i>Kostenlos testen
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-lg mb-2" [routerLink]="['/offer']">
                        <i class="fas fa-file-invoice mr-2"></i>Individuelles Angebot anfordern
                    </button>
                </div>
            </div>

            <div class="features-section mb-5">
                <div class="text-center mb-4">
                    <h2 class="display-4 mb-2">Umfangreiche Funktionen</h2>
                    <p class="lead">Alle Pakete beinhalten diese leistungsstarken Funktionen</p>
                </div>

                <div class="row">
                    <div class="col-lg-10 offset-lg-1">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <h4 class="feature-category-title"><i class="fas fa-tasks text-primary mr-2"></i>Verwaltung</h4>
                                        <ul class="feature-list">
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Unbegrenzte Dokumente</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Unbegrenzte Aufgaben</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Einmalige Termine</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Wiederkehrende Termine</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Erinnerungen</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-4 mb-4">
                                        <h4 class="feature-category-title"><i class="fas fa-chart-bar text-primary mr-2"></i>Berichte</h4>
                                        <ul class="feature-list">
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Exporte nach Excel</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Monatsbericht als PDF</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Monatsvorschau als PDF</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-4 mb-4">
                                        <h4 class="feature-category-title"><i class="fas fa-plus-circle text-primary mr-2"></i>Zusatzfunktionen</h4>
                                        <ul class="feature-list">
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Tags</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>FileShare</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Beliebige Sichtbarkeitsgruppen</span>
                                            </li>
                                            <li>
                                                <i class="fas fa-check-circle text-success mr-2"></i>
                                                <span>Flexible Rechteverwaltung</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cta-section text-center p-5 bg-primary text-white rounded mb-5">
                <h3 class="mb-3">Bereit, Ihre Dokumentenverwaltung zu revolutionieren?</h3>
                <p class="mb-4">Testen Sie NoteRadar kostenlos oder kontaktieren Sie uns, um zu erfahren, wie wir Ihrem Unternehmen helfen können.</p>
                <div class="d-flex justify-content-center flex-wrap">
                    <button type="button" class="btn btn-success btn-lg mr-3 mb-2" [routerLink]="['/demo']">
                        <i class="fas fa-play-circle mr-2"></i>Kostenlos testen
                    </button>
                    <button type="button" class="btn btn-light btn-lg mr-3 mb-2" [routerLink]="['/offer']">
                        <i class="fas fa-file-invoice mr-2"></i>Angebot anfordern
                    </button>
                    <button type="button" class="btn btn-outline-light btn-lg mb-2" [routerLink]="['/contact']">
                        <i class="fas fa-envelope mr-2"></i>Kontakt aufnehmen
                    </button>
                </div>
                <p class="mt-3 small">Erstellen Sie einen kostenlosen Demozugang mit vollem Funktionsumfang für 3 Tage!</p>
            </div>
        </div>
    </div>
</div>
